import axios from "axios";
import { Order } from "types/order";

export interface GetCurrentPatientOrdersItemResponse {
  od_os: string;
  product_name: string;
  tracking_url?: string;
  status_code: string;
  display_status?: string;
}

export interface GetCurrentPatientOrdersResponse {
  OrderNum: number;
  OrderDate: string;
  OrderType: "eyeglasses" | "soft_contacts" | "E" | "S" | "Dry Eye";
  DisplayStatus: string;
  display_byline?: string;
  fulfillmentType?: string;
  FulfillmentDestination?: string;
  FulfillmentDestinationMapUrl?: string;
  ExpectDate: string;
  online_order: boolean;
  is_expandable?: boolean;
  shared_tracking_url?: string;
  items?: GetCurrentPatientOrdersItemResponse[];
}

export interface GetCurrentPatientOrdersPayload {
  total_number_of_orders: number;
  orders: GetCurrentPatientOrdersResponse[];
}

export const getCurrentPatientEcomOrdersRequest = async (
  patientId: string
): Promise<Order[]> => {
  const { data } = await axios.get<GetCurrentPatientOrdersPayload>(
    `/order_details/${patientId}`
  );

  const orders: Order[] = [];
  for (let i = 0; i < data.orders.length; i += 1) {
    const order = data.orders[i];
    orders.push({
      orderNum: order.OrderNum,
      orderDate: order.OrderDate,
      orderTypeName: order.OrderType,
      onlineOrder: order.online_order,
      displayStatus: order.DisplayStatus,
      displayByline: order.display_byline,
      fulfillmentType: order.fulfillmentType,
      fulfillmentDestination: order.FulfillmentDestination,
      fulfillmentDestinationMapUrl: order.FulfillmentDestinationMapUrl,
      expectDate: order.ExpectDate,
      isExpandable: order.is_expandable,
      sharedTrackingUrl: order.shared_tracking_url,
      items: order.items?.map((item) => ({
        odOs: item.od_os,
        productName: item.product_name,
        trackingUrl: item.tracking_url,
        statusCode: item.status_code,
        displayStatus: item.display_status,
      })),
    });
  }

  return orders;
};
